
let c_just_value = 0,
	c_cty_rate = 0,
	c_mun_rate = 0,
	c_sch_rate = 0,
	c_isd_rate = 0,
	c_tot_rate = 0,
	c_adv_taxes = 0,
	c_nav_taxes = 0,
	v_just_value = 0,
	v_est_taxes = 0,
	c_hx_savings = 0,
	c_lx_savings = 0,
	c_wx_savings = 0,
	c_dx_savings = 0,
	v_savings = 0,
	c_cty_taxes = 0,
	c_mun_taxes = 0,
	c_sch_taxes = 0,
	c_isd_taxes = 0,
	v_fund_total = 0,
	v_hasFunds = "",
	v_chart_title = "",
	v_ResidueLabel = "";

let recalcHandle = true;

let paoDetails = {
	client: {
		visitorIP: ''
	},
	chart: {
		taxYear: 0,
		taxYearEstimated: 0,
		initialized: false,
		mode: {
			state: "tax",
			breakdown: {
				show: false,
				fundKey: ""
			}
		}
	},
	context: {
		parid: 0,
		datums: {
			parid: '',
			usesDefaults: false,
			coordinates: {
				lat: '27.491344',
				lon: '-82.414233'
			}
		},
		sqft: 0,
		realRef: 0,
		isLeasingCompany: false,
		isTppParcel: false,
		href: document.location.protocol + "//" + document.location.host,
		child_uri: "",	
		aerial_server: document.location.protocol + "//" + document.location.host + "/photo.server/",
	},
	modules: {
		sketches: {
			loaded: false,
			sketchesUseColor: true
		},
		photos: {
			loaded: false
		},
		streetview: {
			loaded: false
		}
	},
	images: {
		nophoto: "/wp-content/themes/frontier-child/images/NoPhoto2.gif",
		noaerial: document.location.protocol + "//" + document.location.host + "/wp-content/uploads/aerial-not-avail.jpg"
	},
	support: {
		isMobileDevice: false,
		supportsWebGL: false, 
		fullscreenSupported: true,
		fullscreenApi: "", 
		browser: null
	},
	networkStatus: {
		esriAlive: false
	},
	gis: {
		displayPage: "details", 
		referer: null,
		launchBufferWidget: false,
		zoomLevelDefault: 15,
		zoomLevelConveyanceType: 15,
		zoomLevelParcelId: 14,
		zoomLevelSketch: 15,
		ownerSwitched: false,
		mapIsLoaded: false, 
		fullmapWasLoaded: false, 
		services: {
			latestYearAerial: {
				url: "https://www.mymanatee.org/gisimg/rest/services/current/aerials/ImageServer"
			},
			priorYearAerials: {
				url: "https://www.mymanatee.org/gisimg/rest/services"
			},
			mapLayerAndLabels: {
				url: "https://gis.manateepao.gov/arcgis/rest/services/Website/WebLayers/MapServer",
				indices: {
					parcelSearch: 0,
					parcelLines: 1, 
					subdivisions: 21,
					cooperatives: 22,
					condominiums: 23
				}
			},
			districtPLSSLayers: {
				url: "https://gis.manateepao.gov/arcgis/rest/services/Website/DistrictPLSSLayers/MapServer"
			},
			printService: {
				url: "https://gis.manateepao.gov/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task"
			},
			pictoWebSearch: {
				url: "https://gis.manateepao.gov/arcgis/rest/services/Website/PictoWebSearch/MapServer/0"
			},
			geometryServer: {
				url: "https://gis.manateepao.gov/arcgis/rest/services/Utilities/Geometry/GeometryServer"
			},
			postHeleneImagery: {
				url: "https://www.mymanatee.org/gisimg/rest/services/HURRICANE_HELENE/POST_HELENE/ImageServer",
				enabled: true
			},
			postMiltonImagery: {
				url: "https://www.mymanatee.org/gisimg/rest/services/Hurricane_Milton/POST_MILTON_IMAGERY/ImageServer",
				enabled: true
			}
		},
		queryFields: "OBJECTID,PARID,PAR_OWNER_NAME1,PAR_NBHD_NAME,SITUS_ADDRESS,SALE_DATE_LQ,SALE_PRICE_LQ,SALE_VORI_LQ,SALE_CODE_LQ,TAXPARCELTYPE"
	}
};